import {connect} from 'react-redux';

import {AccountsJobModel} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {computeJobProgress} from '../../../../../libs/shared/core/src/models/helpers/jobHelpers';
import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {hideBannerAction} from '../../../../store/panels/app/banners/bannersActions';
import {contactsManagerTableForceRefreshAction} from '../../../../store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {AccountsCSVImportBanner} from './accountsCSVImportBanner';

/*
 * Props.
 */

interface AccountsBannerContainerProps {
  bannerUid: string;
  job?: AccountsJobModel;
  panelId: AppPanelId;
}

/*
 * Selectors.
 */

function getJob(_state: AppState, props: AccountsBannerContainerProps) {
  return props.job;
}

function makeGetProgress() {
  return createSelector([getJob], (job) => (job === undefined ? 0 : computeJobProgress(job)));
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<AccountsBannerContainerProps>()(() => ({
  progress: makeGetProgress(),
}));

const mapDispatchToProps = makeMapDispatchToProps<AccountsBannerContainerProps>()(({panelId, bannerUid}) => ({
  contactsManagerTableForceRefresh: contactsManagerTableForceRefreshAction,
  onDismissClick: () => hideBannerAction(bannerUid),
}));

export const AccountsCSVImportBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountsCSVImportBanner);
